import { VXPay, VXPayAction } from '../../utils/VXPay';
import Translations from '../../utils/Translations';
import Flux from '../../flux/Flux';
import ReloadHelper from '../../utils/ReloadHelper';
import PremiumOnlySwitch from '../SimpleElements/PremiumOnlySwitch';

import { render, unmountComponentAtNode } from 'react-dom';
import PjaxWrapper from '../../utils/PjaxWrapper';

import './../../../../src/VX/Asset/Less/VX/View/TV/TV.less';

function run(premiumOnly = false) {
	const switchElement = document.getElementById('js-switch-button');
	if (switchElement) {
		render(<PremiumOnlySwitch isActive={premiumOnly} />, switchElement);
		PjaxWrapper.addUnloadFunc(() => unmountComponentAtNode(switchElement));
	}

	// buttons for signup / login
	const buttonsLogin = document.querySelectorAll('.js-vxpay-signup-or-login');
	for (let i = 0; i < buttonsLogin.length; i++) {
		const $el = buttonsLogin[i];
		if (!$el.dataset['clickListener']) {
			$el.dataset['clickListener'] = 'true';
			$el.addEventListener('click', function (event) {
				if (event.preventDefault) {
					event.preventDefault();
				}
				VXPay.openSignupOrLogin({
					hostData: {
						teaserText: Translations.get('TVTeaserVXPayLogin'),
						teaserMotto: Translations.get('TVTeaserVXPayLoginMotto'),
					},
					customizedSignup: 'tvabo',
				});
			});
		}
	}

	// buttons for AVS
	const buttonsAvs = document.querySelectorAll('.js-vxpay-avs');
	for (let i = 0; i < buttonsAvs.length; i++) {
		const $el = buttonsAvs[i];
		if (!$el.dataset['clickListener']) {
			$el.dataset['clickListener'] = 'true';
			$el.addEventListener('click', function (event) {
				if (event.preventDefault) {
					event.preventDefault();
				}
				VXPay.openAVS();
			});
		}
	}

	// buttons for VX TV Premium Abo
	const buttonsVXTVAbo = document.querySelectorAll('.js-vxpay-vxtv');
	for (let i = 0; i < buttonsVXTVAbo.length; i++) {
		const $el = buttonsVXTVAbo[i];
		if (!$el.dataset['clickListener']) {
			$el.dataset['clickListener'] = 'true';
			$el.addEventListener('click', function (event) {
				if (event.preventDefault) {
					event.preventDefault();
				}

				if (!Flux.Guest.isLoggedIn()) {
					const tvAboAction = new VXPayAction(Flux.Constants.ActionTypes.VXPay.SHOW_VXTVABO);
					VXPay.openSignupOrLogin(
						{
							hostData: {
								teaserText: Translations.get('TVTeaserVXPayLogin'),
								teaserMotto: Translations.get('TVTeaserVXPayLoginMotto'),
							},
							customizedSignup: 'tvabo',
						},
						tvAboAction,
					);
				} else {
					VXPay.openVXTVAbo({
						hostData: {
							teaserText: Translations.get('TVTeaserVXPayLogin'),
							teaserMotto: Translations.get('TVTeaserVXPayLoginMotto'),
						},
					});
				}
			});
		}
	}

	const linkVXTVAboRedirect = document.querySelectorAll('.js-vxpay-vxtv-redirect');
	for (let i = 0; i < linkVXTVAboRedirect.length; i++) {
		const $el = linkVXTVAboRedirect[i];
		if (!$el.dataset['clickListener']) {
			$el.dataset['clickListener'] = 'true';
			$el.addEventListener('click', function (event) {
				if (event.preventDefault) {
					event.preventDefault();
				}

				if (!Flux.Guest.isLoggedIn()) {
					const tvAboAction = new VXPayAction(Flux.Constants.ActionTypes.VXPay.SHOW_VXTVABO, {
						targetUrl: $el.getAttribute('href'),
					});
					VXPay.openSignupOrLogin(
						{
							hostData: {
								teaserText: Translations.get('TVTeaserVXPayLogin'),
								teaserMotto: Translations.get('TVTeaserVXPayLoginMotto'),
							},
							customizedSignup: 'tvabo',
						},
						tvAboAction,
					);
				} else {
					if (!Flux.Guest.isPremium()) {
						VXPay.onVXTVAboSuccess(() => ReloadHelper.reload($el.getAttribute('href')));
					} else {
						ReloadHelper.reload($el.getAttribute('href'));
						return;
					}

					VXPay.openVXTVAbo({
						hostData: {
							teaserText: Translations.get('TVTeaserVXPayLogin'),
							teaserMotto: Translations.get('TVTeaserVXPayLoginMotto'),
						},
					});
				}
			});
		}
	}
}

export { run };
